/* eslint-disable react/prop-types */
import { observer } from "mobx-react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { DynamicProduct } from '../dynamic-imports';
import ArrowTwoIcon from '../svg/ArrowTwoIcon';
import studioStore from '@/stores/studioStore';
import 'swiper/css';

const ProductsSlider = observer(({
  sectionTitle,
  backgroundColor,
  products,
  crossSellProducts,
}) => {
  const primaryColor = studioStore?.settings?.colors?.primary_color;

  return (
    <div className="section-products-slider py-8 relative" style={{backgroundColor: backgroundColor}}>
      <div className="2xl:container mx-auto px-2 2xl:px-0">
        <h2 className="text-center pb-8 text-4xl font-secondary" style={{color: primaryColor}}>
          {sectionTitle}
        </h2>
        <div className="products-slider px-3 md:px-12 relative">
          {/* Custom navigation buttons */}
          <div className="swiper-button-prev custom-nav-btn absolute right-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer w-10 h-10 flex items-center justify-center">
            <ArrowTwoIcon width="20px" fill={primaryColor} direction="right" />
          </div>
          <div className="swiper-button-next custom-nav-btn absolute left-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer w-10 h-10 flex items-center justify-center">
            <ArrowTwoIcon width="20px" fill={primaryColor} direction="left" />
          </div>

          <Swiper
            spaceBetween={30}
            slidesPerView={1}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            modules={[Navigation]}
            className="px-12"
            breakpoints={{
              768: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
              1330: {
                slidesPerView: 5,
                spaceBetween: 30,
              },
              1440: {
                slidesPerView: 6,
                spaceBetween: 30,
              },
            }}
          >
            {products?.map((product) => (
              <SwiperSlide key={product.id}>
                <DynamicProduct product={product} crossSellProducts={crossSellProducts} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <style jsx global>{`
        .custom-nav-btn {
          transition: opacity 0.2s ease-in-out;
        }

        .custom-nav-btn:hover {
          opacity: 0.8;
        }

        .custom-nav-btn.swiper-button-disabled {
          opacity: 0.35;
          cursor: not-allowed;
        }

        .swiper-button-next::after,
        .swiper-button-prev::after {
          content: none !important;
        }
      `}</style>
    </div>
  );
});

export default ProductsSlider;